import React from 'react'

const CookieBanner: React.FC<{
  closeCallback: () => void
  hiddenClass: string
}> = ({ closeCallback, hiddenClass }) => {
  const privacyHref = 'https://bunny.net/privacy'

  return (
    <div className={`bn-cookies-wr ${hiddenClass}`}>
      <img src="/bn-cookies/bn-cookies.svg" alt="Cookie message" />
      <div className="message">
        We use cookies to improve your user experience.{' '}
        <a href={privacyHref}>Learn more</a>
      </div>
      <div className="close" onClick={closeCallback}>
        x
      </div>
    </div>
  )
}

export const COOKIE_COOKIES = 'bn_cookies'

export default CookieBanner
